import api from 'api';
import { useReduxState } from 'hooks';
import { ConfirmButton } from 'components/common';

import type { UserCustomAttribute } from 'shared-types';

interface Props {
  attribute: UserCustomAttribute;
  optionGroupIndex: number;
  optionIndex: number;
  updateData: () => Promise<void>;
}

const UserAttributesOptionsDelete = ({
  attribute,
  optionGroupIndex,
  optionIndex,
  updateData
}: Props) => {
  const { messages } = useReduxState();

  const optionGroup = attribute.optionGroups[optionGroupIndex];

  const handleConfirm = async () => {
    const data = {
      optionGroups: [
        ...attribute.optionGroups.slice(0, optionGroupIndex),
        {
          ...optionGroup,
          options: [
            ...optionGroup.options.slice(0, optionIndex),
            ...optionGroup.options.slice(optionIndex + 1)
          ]
        },
        ...attribute.optionGroups.slice(optionGroupIndex + 1)
      ]
    };

    await api.put(`/admin/user-custom-attributes/${attribute.id}`, data);

    await updateData();

    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonDelete}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={messages.commonDelete}
      category="danger"
      confirmText={messages.commonDeleteOptionConfirm}
      confirmTitle={messages.commonDeleteOption}
      onConfirm={handleConfirm}
      successMessage={messages.commonChangesSavesSuccessfully}
    />
  );
};

export default UserAttributesOptionsDelete;
